import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b0c1e3ce&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0c1e3ce')) {
      api.createRecord('b0c1e3ce', component.options)
    } else {
      api.reload('b0c1e3ce', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=b0c1e3ce&", function () {
      api.rerender('b0c1e3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/layout/App.vue"
export default component.exports